import React, { Component } from 'react';
import { Modal } from 'antd';

import CapacitacionFormulario from './CapacitacionFormulario';

class CapacitacionFormularioModal extends Component {
  handleClose = () => {
    this.props.onCancel();
  };

  handleFormSubmit = (data) => {
    this.props.onFormSubmit(data);
  };

  onFormUploadValidators = (error) => {
    if (this.formRef) {
      this.formRef.actualizarListaErrores(error);
    }
  };

  render() {
    return (
      <div>
        <Modal
          title={this.props.capacitacion && this.props.capacitacion.id ? 'Editar Capacitación' : 'Nueva Capacitación'}
          visible={this.props.visible}
          onCancel={this.handleClose}
          width={850}
          footer={null}
          maskClosable={false}
        >
          <CapacitacionFormulario
            ref={this.setFormRef}
            onFormSubmit={this.handleFormSubmit}
            onFormCancel={this.handleClose}
            capacitacion={this.props.capacitacion}
            guardando={this.props.guardando}
            errores={this.props.errores}
          />
        </Modal>
      </div>
    );
  }
}

export default CapacitacionFormularioModal;
